// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './TopSection.module.scss';

const TopSection: PageComponent = () => {
    return (
        <section className={styles.section}>
            <div className={`container ${styles.container}`}>
                <div className={styles.text}>
                    <h1>
                        <Trans
                            i18nKey="title"
                            ns="landingInformationAboutCompany"
                        >
                            Apie kompanija
                        </Trans>
                    </h1>
                </div>
            </div>

            <div className={styles.bottom_container}>
                <div className={styles.bottom_inner}>
                    <img
                        src="/static/img/background-bottom.svg"
                        className={styles.img_bg}
                    />
                </div>
            </div>
        </section>
    );
};

export default TopSection;
